import { render, staticRenderFns } from "./Accessibilite.vue?vue&type=template&id=6187ed4c&"
import script from "./Accessibilite.vue?vue&type=script&lang=js&"
export * from "./Accessibilite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports